import { useState, useRef, useEffect } from 'react';

var useTrueElementSize = function (elementRef) {
    var _a = useState(0), elementWidth = _a[0], setElementWidth = _a[1];
    var _b = useState(0), elementHeight = _b[0], setElementHeight = _b[1];
    var observer = useRef(new ResizeObserver(function (entries) {
        var _a = entries[0].target, clientWidth = _a.clientWidth, clientHeight = _a.clientHeight;
        setElementWidth(clientWidth);
        setElementHeight(clientHeight);
    }));
    useEffect(function () {
        if (!elementRef.current || elementHeight || elementWidth)
            return;
        observer.current.observe(elementRef.current);
    });
    useEffect(function () {
        if (elementRef.current) {
            observer.current.observe(elementRef.current);
        }
        return function () {
            elementRef.current && observer.current.unobserve(elementRef.current);
        };
    }, [elementRef, observer]);
    return { elementWidth: elementWidth, elementHeight: elementHeight };
};

export { useTrueElementSize };
//# sourceMappingURL=index.es.js.map
